
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-54015394\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!./detailAbsence.scss")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./detailAbsence.ts"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-54015394\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./detailAbsence.vue.html"),
  /* scopeId */
  "data-v-54015394",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ficheSalarie/absences/detailAbsence/detailAbsence.vue.html
// module id = g3n0
// module chunks = 2